import { useNavigate, useParams } from 'react-router-dom';
import { Box } from '@mui/material';
import { useRef, useState } from 'react';
import { updateOrCreate } from '../../../components/special/updateOrCreate';
import ExoDialog from '../../../components/exo/ExoDialog';
import NewRecurringReceipt from '../../../components/new/NewRecurringReceipt';
import ExtendRecurringReceipt from './ExtendRecurringReceipt';

export const ShowRecurringReceipt = () => {
  const { id } = useParams();
  const extendRef = useRef(null);
  //const { apiData, setApiData } = useFetch("receipts");

  const navigate = useNavigate();

  const [newRecurringReceipt, setNewRecurringReceipt] = useState(false);

  // actions
  const [recurringReceiptToEdit, setRecurringReceiptToEdit] = useState(null);
  function handleClickEdit(data) {
    
    setRecurringReceiptToEdit({
      ...data,
      recurringReceipt: {
        amount: data.amount,
        position: data.position,
        taxAssignment: data.taxAssignment,
        taxRate: data.taxRate,
        costCenter: data.costCenter,
        note: data.note,
      },
    });
    setNewRecurringReceipt(true);
  }  

  function handleCreateRecurringReceipt(newRecurringReceipt, status) {
    extendRef.current.setData(newRecurringReceipt);
    setNewRecurringReceipt(false);
    if (status === 201) {
      navigate('/expenses');
    }
  }

  function handleDelete() {
    navigate('/expenses');
  }

  return (
    <Box className="pt-0 md:pt-12 w-full h-full flex flex-col">
      <ExtendRecurringReceipt
        ref={extendRef}
        row={{
          id,
          onUpdate: () => {},
          onDelete: () => {},
        }}
        //onUpdate={onUpdate}
        onClickEdit={handleClickEdit}
        onDelete={handleDelete}
      />
      <ExoDialog open={newRecurringReceipt}>
        <NewRecurringReceipt
          onCreate={handleCreateRecurringReceipt}
          onClose={() => setNewRecurringReceipt(false)}
          recurringReceipt={recurringReceiptToEdit}
          open={newRecurringReceipt}
        />
      </ExoDialog>
    </Box>
  );
};
